// Eager-registers all Stimulus controllers in this directory.
// Controllers are added one per task (T13–T18); each task appends an import + register call.
import { application } from "./application"

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import ColumnFilterController from "./column_filter_controller"
application.register("column-filter", ColumnFilterController)

import ColumnsController from "./columns_controller"
application.register("columns", ColumnsController)

import SelectionController from "./selection_controller"
application.register("selection", SelectionController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import ScrollMemoryController from "./scroll_memory_controller"
application.register("scroll-memory", ScrollMemoryController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import PreviewRefreshController from "./preview_refresh_controller"
application.register("preview-refresh", PreviewRefreshController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import MappingRowController from "./mapping_row_controller"
application.register("mapping-row", MappingRowController)

import ConditionsEditorController from "./conditions_editor_controller"
application.register("conditions-editor", ConditionsEditorController)

import ConcatPartController from "./concat_part_controller"
application.register("concat-part", ConcatPartController)

import ValueKindController from "./value_kind_controller"
application.register("value-kind", ValueKindController)

import CondBranchController from "./cond_branch_controller"
application.register("cond-branch", CondBranchController)

import ColumnPickerController from "./column_picker_controller"
application.register("column-picker", ColumnPickerController)

import NavMenuController from "./nav_menu_controller"
application.register("nav-menu", NavMenuController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import SubmitLoadingController from "./submit_loading_controller"
application.register("submit-loading", SubmitLoadingController)

import ClockController from "./clock_controller"
application.register("clock", ClockController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import TimecardSplitController from "./timecard_split_controller"
application.register("timecard-split", TimecardSplitController)

import ActionConfirmController from "./action_confirm_controller"
application.register("action-confirm", ActionConfirmController)

import SnoozeMenuController from "./snooze_menu_controller"
application.register("snooze-menu", SnoozeMenuController)

import ChannelFieldsController from "./channel_fields_controller"
application.register("channel-fields", ChannelFieldsController)

import UploadFormController from "./upload_form_controller"
application.register("upload-form", UploadFormController)

export { application }
